import { CommunityRequestListingSignupPanel } from "components/communities/show-community/community-request-listing-signup-panel";
import { CommunityRequestPricingUpdatePanel } from "components/communities/show-community/community-request-pricing-update-panel";
import { defaultLinkStyle } from "components/ui/link";
import { ObservationKind } from "generated/graphql";
import React, { useCallback } from "react";
import { ListableCommunity } from "../props";

interface LayoutItemPricingMissingProps {
    community: ListableCommunity;
    canRequestPricing: boolean;
    canRequestParticipation: boolean;
}

export const LayoutItemPricingMissing: React.FC<
    LayoutItemPricingMissingProps
> = props => {
    const { community, canRequestPricing, canRequestParticipation } = props;

    const [isRequestPricingDialogOpen, setIsRequestPricingDialogOpen] =
        React.useState(false);
    const [isRequestParticipationDialogOpen, setIsRequestParticipationDialogOpen] =
        React.useState(false);

    const requestPricing = useCallback(() => {
        setIsRequestPricingDialogOpen(true);
    }, []);

    const requestParticipation = useCallback(() => {
        setIsRequestParticipationDialogOpen(true);
    }, []);

    const closeRequestPricingDialog = useCallback(() => {
        setIsRequestPricingDialogOpen(false);
    }, []);

    const closeRequestParticipationDialog = useCallback(() => {
        setIsRequestParticipationDialogOpen(false);
    }, []);

    const onRequestPricingSuccess = useCallback(() => {
        closeRequestPricingDialog();
    }, [closeRequestPricingDialog]);

    const onRequestParticipationSuccess = useCallback(() => {
        closeRequestParticipationDialog();
    }, [closeRequestParticipationDialog]);

    return (
        <>
            {isRequestPricingDialogOpen ? (
                <CommunityRequestPricingUpdatePanel
                    communityId={community.id}
                    communityName={community.name}
                    onDismiss={closeRequestPricingDialog}
                    onSuccess={onRequestPricingSuccess}
                />
            ) : null}
            {isRequestParticipationDialogOpen ? (
                <CommunityRequestListingSignupPanel
                    communityId={community.id}
                    onDismiss={closeRequestParticipationDialog}
                    onSuccess={onRequestParticipationSuccess}
                    observationFocus={ObservationKind.Pricing}
                />
            ) : null}
            {canRequestPricing ? (
                <dd className="mt-1 flex text-sm">
                    <a
                        href="#"
                        onClick={e => {
                            e.preventDefault();
                            requestPricing();
                        }}
                        className={`${defaultLinkStyle} text-sm`}>
                        Request Pricing
                    </a>
                </dd>
            ) : canRequestParticipation ? (
                <dd className="mt-1 flex text-sm">
                    <a
                        href="#"
                        onClick={e => {
                            e.preventDefault();
                            requestParticipation();
                        }}
                        className={`${defaultLinkStyle} text-sm`}>
                        Request Pricing
                    </a>
                </dd>
            ) : null}
        </>
    );
};
